import { render, staticRenderFns } from "./customLink.vue?vue&type=template&id=5c3e193c&"
import script from "./customLink.vue?vue&type=script&lang=js&"
export * from "./customLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports